// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;700&amp;display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --mainColor: rgb(26 35 126 / var(--tw-bg-opacity, 1));;
    --mainColorLight: #5767aa;
    --secondaryColor: #97a7ff;
    --textColor: #ffffff;
    --topBarColor: #ebae5e;
}

:root[data-theme="dark"] {
    --mainColor: #1a202c;
    --mainColorLight: #2d3748;
    --secondaryColor: #63b3ed;
    --textColor: #e2e8f0;
    --topBarColor: #2d3748;
}

:root[data-theme="white"] {
    --mainColor: rgb(26 35 126 / var(--tw-bg-opacity, 1));;
    --mainColorLight: #5767aa;
    --secondaryColor: #97a7ff;
    --textColor: #ffffff;
    --topBarColor: #ebae5e;
}

body {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin: 0;
    padding: 0;
    font-family: "Titillium Web", sans-serif;
}

.responsive-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: var(--mainColor);
    color: var(--textColor);
    z-index: 1000;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1.5rem;
    max-width: 1400px;
    margin: 0 auto;
}

.logo-container {
    display: flex;
    align-items: center;
}

.logo-container h2 {
    margin: 0;
    font-size: 1.5rem;
}

.main-nav {
    display: flex;
    align-items: center;
}

.nav-links {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 1rem;
}

.nav-links li {
    margin: 0;
    position: relative;
}

.nav-links a {
    color: var(--textColor);
    text-decoration: none;
    display: flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
    border-radius: 4px;
    transition: background-color 0.3s, color 0.3s;
}

.nav-links a:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: var(--secondaryColor);
}

.nav-links .theme-toggle-btn {
    background-color: rgba(255, 255, 255, 0.1);
}

.nav-links .theme-toggle-btn:hover {
    background-color: rgba(255, 255, 255, 0.2);
}

.theme-icon {
    color: #ffd700;
}

.nav-links[data-theme="dark"] .theme-icon {
    color: #ffffff; 
}

.nav-icon {
    margin-right: 8px;
    font-size: 1.2rem;
}

.submenu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: var(--mainColor);
    list-style: none;
    padding: 0.5rem 0;
    margin: 0;
    min-width: 200px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
}

.submenu.active {
    display: block;
}

.submenu li {
    margin: 0;
}

.submenu a {
    padding: 0.5rem 1rem;
    display: block;
}

/* Оновлено: user-info тепер абсолютно позиціонований під основним хедером */
.user-info {
    position: absolute;
    top: 100%; /* Розташовується прямо під основним хедером */
    left: 0;
    right: 0;
    background-color: var(--topBarColor);
    padding: 0.5rem 1.5rem;
    color: #000000;
    font-weight: bold;
    z-index: 999; /* Трохи нижчий z-index ніж у хедера */
}

:root[data-theme="dark"] .user-info {
    background-color: var(--topBarColor);
    color: var(--textColor);
}

.user-info-content {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.username {
    margin-right: 2rem;
}

.sub-nav-container {
    flex: 1 1;
    display: flex;
    justify-content: center;
}

.sub-nav-links {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 2rem;
    align-items: center;
}

.sub-nav-links li {
    margin: 0;
}

.sub-nav-links a {
    color: #020202;
    text-decoration: none;
    padding: 0.25rem 0.5rem;
    transition: opacity 0.3s;
}

:root[data-theme="dark"] .sub-nav-links a {
    color: var(--textColor);
}

.sub-nav-links a:hover {
    opacity: 0.7;
}

.telegram-container {
    display: flex;
}

.telegram-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--mainColor);
    color: var(--textColor);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s;
}

.telegram-btn:hover {
    background-color: var(--mainColorLight);
}

.menu-toggle {
    display: none;
    background: transparent;
    border: none;
    color: var(--textColor);
    font-size: 1.5rem;
    cursor: pointer;
}

.login-link {
    color: var(--textColor);
    text-decoration: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    background-color: var(--mainColorLight);
}


.content-spacer {
    height: 70px; 
}

@media (max-width: 992px) {
    .nav-links {
        gap: 0.5rem;
    }
    
    .nav-links a {
        padding: 0.4rem 0.6rem;
        font-size: 0.9rem;
    }
    
    .sub-nav-links {
        gap: 1rem;
    }
}

@media (max-width: 768px) {
    .menu-toggle {
        display: block;
    }
    
    .main-nav {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background-color: var(--mainColor);
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
    }
    
    .main-nav.active {
        max-height: 600px; 
    }
    
    .nav-links {
        flex-direction: column;
        width: 100%;
        padding: 1rem;
    }
    
    .nav-links li {
        width: 100%;
    }
    
    .nav-links a {
        width: 100%;
        padding: 0.75rem;
    }
    
    .submenu {
        position: static;
        box-shadow: none;
        padding-left: 1rem;
        background-color: rgba(255, 255, 255, 0.05);
    }
    
    .user-info {
        display: none;
    }
    
    /* На мобільних пристроях потрібен менший відступ, оскільки user-info не відображається */
    .content-spacer {
        height: 5px;
        background-color: rgba(255, 255, 255, 0.05);
    }
}

@media (max-width: 576px) {
    .logo-container h2 {
        font-size: 1.2rem;
    }
    
    .nav-links a span {
        font-size: 0.9rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAEA;IACI,qDAAqD;IACrD,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,qDAAqD;IACrD,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,SAAS;IACT,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,kCAAkC;IAClC,uBAAuB;IACvB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,SAAS;AACb;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,0CAA0C;IAC1C,4BAA4B;AAChC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA,4EAA4E;AAC5E;IACI,kBAAkB;IAClB,SAAS,EAAE,8CAA8C;IACzD,OAAO;IACP,QAAQ;IACR,oCAAoC;IACpC,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,YAAY,EAAE,sCAAsC;AACxD;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,uCAAuC;AAC3C;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,QAAQ;QACR,kCAAkC;QAClC,aAAa;QACb,gBAAgB;QAChB,gCAAgC;IACpC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,2CAA2C;IAC/C;;IAEA;QACI,aAAa;IACjB;;IAEA,yFAAyF;IACzF;QACI,WAAW;QACX,2CAA2C;IAC/C;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;700&amp;display=swap\");\r\n\r\n:root {\r\n    --mainColor: rgb(26 35 126 / var(--tw-bg-opacity, 1));;\r\n    --mainColorLight: #5767aa;\r\n    --secondaryColor: #97a7ff;\r\n    --textColor: #ffffff;\r\n    --topBarColor: #ebae5e;\r\n}\r\n\r\n:root[data-theme=\"dark\"] {\r\n    --mainColor: #1a202c;\r\n    --mainColorLight: #2d3748;\r\n    --secondaryColor: #63b3ed;\r\n    --textColor: #e2e8f0;\r\n    --topBarColor: #2d3748;\r\n}\r\n\r\n:root[data-theme=\"white\"] {\r\n    --mainColor: rgb(26 35 126 / var(--tw-bg-opacity, 1));;\r\n    --mainColorLight: #5767aa;\r\n    --secondaryColor: #97a7ff;\r\n    --textColor: #ffffff;\r\n    --topBarColor: #ebae5e;\r\n}\r\n\r\nbody {\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    background-position: center;\r\n    margin: 0;\r\n    padding: 0;\r\n    font-family: \"Titillium Web\", sans-serif;\r\n}\r\n\r\n.responsive-header {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    background-color: var(--mainColor);\r\n    color: var(--textColor);\r\n    z-index: 1000;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.header-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 0.5rem 1.5rem;\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.logo-container {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.logo-container h2 {\r\n    margin: 0;\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.main-nav {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.nav-links {\r\n    display: flex;\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    gap: 1rem;\r\n}\r\n\r\n.nav-links li {\r\n    margin: 0;\r\n    position: relative;\r\n}\r\n\r\n.nav-links a {\r\n    color: var(--textColor);\r\n    text-decoration: none;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0.5rem 0.75rem;\r\n    border-radius: 4px;\r\n    transition: background-color 0.3s, color 0.3s;\r\n}\r\n\r\n.nav-links a:hover {\r\n    background-color: rgba(255, 255, 255, 0.1);\r\n    color: var(--secondaryColor);\r\n}\r\n\r\n.nav-links .theme-toggle-btn {\r\n    background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.nav-links .theme-toggle-btn:hover {\r\n    background-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.theme-icon {\r\n    color: #ffd700;\r\n}\r\n\r\n.nav-links[data-theme=\"dark\"] .theme-icon {\r\n    color: #ffffff; \r\n}\r\n\r\n.nav-icon {\r\n    margin-right: 8px;\r\n    font-size: 1.2rem;\r\n}\r\n\r\n.submenu {\r\n    display: none;\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    background-color: var(--mainColor);\r\n    list-style: none;\r\n    padding: 0.5rem 0;\r\n    margin: 0;\r\n    min-width: 200px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n    border-radius: 4px;\r\n}\r\n\r\n.submenu.active {\r\n    display: block;\r\n}\r\n\r\n.submenu li {\r\n    margin: 0;\r\n}\r\n\r\n.submenu a {\r\n    padding: 0.5rem 1rem;\r\n    display: block;\r\n}\r\n\r\n/* Оновлено: user-info тепер абсолютно позиціонований під основним хедером */\r\n.user-info {\r\n    position: absolute;\r\n    top: 100%; /* Розташовується прямо під основним хедером */\r\n    left: 0;\r\n    right: 0;\r\n    background-color: var(--topBarColor);\r\n    padding: 0.5rem 1.5rem;\r\n    color: #000000;\r\n    font-weight: bold;\r\n    z-index: 999; /* Трохи нижчий z-index ніж у хедера */\r\n}\r\n\r\n:root[data-theme=\"dark\"] .user-info {\r\n    background-color: var(--topBarColor);\r\n    color: var(--textColor);\r\n}\r\n\r\n.user-info-content {\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.username {\r\n    margin-right: 2rem;\r\n}\r\n\r\n.sub-nav-container {\r\n    flex: 1;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.sub-nav-links {\r\n    display: flex;\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    gap: 2rem;\r\n    align-items: center;\r\n}\r\n\r\n.sub-nav-links li {\r\n    margin: 0;\r\n}\r\n\r\n.sub-nav-links a {\r\n    color: #020202;\r\n    text-decoration: none;\r\n    padding: 0.25rem 0.5rem;\r\n    transition: opacity 0.3s;\r\n}\r\n\r\n:root[data-theme=\"dark\"] .sub-nav-links a {\r\n    color: var(--textColor);\r\n}\r\n\r\n.sub-nav-links a:hover {\r\n    opacity: 0.7;\r\n}\r\n\r\n.telegram-container {\r\n    display: flex;\r\n}\r\n\r\n.telegram-btn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: var(--mainColor);\r\n    color: var(--textColor);\r\n    width: 36px;\r\n    height: 36px;\r\n    border-radius: 50%;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n}\r\n\r\n.telegram-btn:hover {\r\n    background-color: var(--mainColorLight);\r\n}\r\n\r\n.menu-toggle {\r\n    display: none;\r\n    background: transparent;\r\n    border: none;\r\n    color: var(--textColor);\r\n    font-size: 1.5rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.login-link {\r\n    color: var(--textColor);\r\n    text-decoration: none;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 4px;\r\n    background-color: var(--mainColorLight);\r\n}\r\n\r\n\r\n.content-spacer {\r\n    height: 70px; \r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .nav-links {\r\n        gap: 0.5rem;\r\n    }\r\n    \r\n    .nav-links a {\r\n        padding: 0.4rem 0.6rem;\r\n        font-size: 0.9rem;\r\n    }\r\n    \r\n    .sub-nav-links {\r\n        gap: 1rem;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .menu-toggle {\r\n        display: block;\r\n    }\r\n    \r\n    .main-nav {\r\n        position: absolute;\r\n        top: 100%;\r\n        left: 0;\r\n        right: 0;\r\n        background-color: var(--mainColor);\r\n        max-height: 0;\r\n        overflow: hidden;\r\n        transition: max-height 0.3s ease;\r\n    }\r\n    \r\n    .main-nav.active {\r\n        max-height: 600px; \r\n    }\r\n    \r\n    .nav-links {\r\n        flex-direction: column;\r\n        width: 100%;\r\n        padding: 1rem;\r\n    }\r\n    \r\n    .nav-links li {\r\n        width: 100%;\r\n    }\r\n    \r\n    .nav-links a {\r\n        width: 100%;\r\n        padding: 0.75rem;\r\n    }\r\n    \r\n    .submenu {\r\n        position: static;\r\n        box-shadow: none;\r\n        padding-left: 1rem;\r\n        background-color: rgba(255, 255, 255, 0.05);\r\n    }\r\n    \r\n    .user-info {\r\n        display: none;\r\n    }\r\n    \r\n    /* На мобільних пристроях потрібен менший відступ, оскільки user-info не відображається */\r\n    .content-spacer {\r\n        height: 5px;\r\n        background-color: rgba(255, 255, 255, 0.05);\r\n    }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .logo-container h2 {\r\n        font-size: 1.2rem;\r\n    }\r\n    \r\n    .nav-links a span {\r\n        font-size: 0.9rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
